export default __webpack_public_path__ + "static/media/1.27646f18.png";